export default "__VITE_ASSET__D7hgF9Ef__"